import { createContext } from 'react';

export const AgegateContext = createContext({
  confirmedAge: false,
  handleAcceptClick: () => {},
  handleAcceptKeyup: () => {},
});
